// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2BSoe","item":"PaymentsMobile_item__gtnp5","label":"PaymentsMobile_label__et2Ge","amount":"PaymentsMobile_amount__3Uty4"};